/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GetPasLastViewed200Response
 */
export interface GetPasLastViewed200Response {
    /**
     * 
     * @type {string}
     * @memberof GetPasLastViewed200Response
     */
    pasLastViewedDate?: string;
}


/**
 * Check if a given object implements the GetPasLastViewed200Response interface.
 */
export function instanceOfGetPasLastViewed200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function GetPasLastViewed200ResponseFromJSON(json: any): GetPasLastViewed200Response {
    return GetPasLastViewed200ResponseFromJSONTyped(json, false);
}

export function GetPasLastViewed200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPasLastViewed200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'pasLastViewedDate': !exists(json, 'pasLastViewedDate') ? undefined : json['pasLastViewedDate'],
    };
}

export function GetPasLastViewed200ResponseToJSON(value?: GetPasLastViewed200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'pasLastViewedDate': value.pasLastViewedDate,
    };
}

